import React from 'react';
import { connect } from 'react-redux';
import styles from './cluster-page.scss';
import PropTypes from 'prop-types';
import BubbleChart from '../../components/bubble-chart';
import Lines from '../../components/lines';
import SupportingClusterInfo from '../../components/supporting-cluster-info';
import * as selectors from '../../reducers';
import { camelCase, orderBy } from 'lodash';
import { setActiveProject } from '../../actions/index';
import ClusterHeadlineAndToolTip from '../../components/cluster-headline-and-tooltip';

const clusterLinks = {
  'The Treasury': 'https://digital.nsw.gov.au/cluster/treasury',
  Health: 'https://digital.nsw.gov.au/cluster/health',
  Education: 'https://digital.nsw.gov.au/cluster/education',
  Justice: 'https://digital.nsw.gov.au/cluster/justice',
  'Premier and Cabinet':
    'https://digital.nsw.gov.au/cluster/premier-and-cabinet',
  'Family and Community Services': 'https://digital.nsw.gov.au/cluster/facs',
  Transport: 'https://digital.nsw.gov.au/cluster/transport',
  'Finance, Services and Innovation': 'https://digital.nsw.gov.au/cluster/dfsi',
  Industry: 'https://digital.nsw.gov.au/cluster/industry',
  'Planning and Environment':
    'https://digital.nsw.gov.au/cluster/planning-environment',
};

class ClusterPage extends React.PureComponent {
  isSupportingCluster(cluster, supportingClusters) {
    if (supportingClusters && supportingClusters.length > 0) {
      return supportingClusters.includes(cluster);
    } else return false;
  }

  getClusterOpacity(cluster, activeProject) {
    if (
      (activeProject && activeProject.cluster === cluster) ||
      !activeProject ||
      this.isSupportingCluster(cluster, activeProject.clusters_other)
    ) {
      return 1;
    } else return 0.3;
  }

  getLines() {
    const { activeProject } = this.props;
    if (
      !activeProject ||
      !activeProject.clusters_other ||
      activeProject.clusters_other.length === 0
    )
      return null;

    return activeProject.clusters_other.map(cluster => {
      return {
        from: '#project' + activeProject.id,
        to: '#cluster' + camelCase(cluster),
      };
    });
  }

  renderSupportingClusterInfo() {
    return this.getLines() ? <SupportingClusterInfo /> : null;
  }

  // getLinesFromAll() {
  //   const { activeProject, projects } = this.props;
  //   if (!activeProject) return null;
  //   var lines = [];
  //   projects.forEach(project => {
  //     if (project.clusters_other && project.clusters_other.length > 0) {
  //       project.clusters_other.forEach(cluster => {
  //         console.log(cluster);
  //         lines.push({
  //           from: '#project' + project.id,
  //           to: '#cluster' + camelCase(cluster),
  //         });
  //       });
  //     }
  //   });
  //   return lines;
  // }

  getSortedClusterNames() {
    const { projectsByCluster } = this.props;
    const clusters = [];
    Object.keys(projectsByCluster).forEach(cluster => {
      clusters.push({
        name: cluster,
        size: projectsByCluster[cluster].length,
        link: clusterLinks[cluster],
      });
    });
    return orderBy(clusters, 'size');
  }
  renderClusters() {
    const { projectsByCluster, activeProject } = this.props;
    return this.getSortedClusterNames().map(cluster => {
      const opacity = this.getClusterOpacity(cluster.name, activeProject);
      return (
        <div
          key={cluster.name}
          className={styles.cluster}
          style={{ opacity: opacity }}
        >
          <ClusterHeadlineAndToolTip
            title={cluster.name}
            data={projectsByCluster[cluster.name]}
            link={cluster.link}
          />
          <BubbleChart
            title={cluster.name}
            data={projectsByCluster[cluster.name]}
            canvasId={'clusterWrapper'}
          />
        </div>
      );
    });
  }
  render() {
    return (
      <div
        className={styles.clusterWrapper}
        id={'clusterWrapper'}
        ref={d => {
          this.container = d;
        }}
      >
        {this.renderClusters()}
        {this.renderSupportingClusterInfo()}
        <Lines container={this.container} lines={this.getLines()} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  projectsByCluster: selectors.getProjectsByCluster(state),
  activeProject: selectors.getActiveProject(state),
  projects: selectors.getAllProjects(state),
});

ClusterPage.propTypes = {
  projectsByCluster: PropTypes.object,
  activeProject: PropTypes.object,
  setActiveProject: PropTypes.func.isRequired,
  projects: PropTypes.array,
};

export default connect(mapStateToProps, { setActiveProject })(ClusterPage);



// WEBPACK FOOTER //
// ./src/pages/cluster-page/cluster-page.js